import React, { forwardRef, useImperativeHandle } from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import { Button, DatePicker, Form, Input, InputNumber, Select } from 'antd'
import { Col, Grid, Row } from 'react-flexbox-grid'
import * as Constants from '../../../constants'
import TextArea from 'antd/lib/input/TextArea'

const { Option } = Select

const FormObstaclesWorkOrder = forwardRef((props, ref) => {
    const { loading, onSubmitObstacleWorkOrder, workOrderToEdit, obstacles } = props
    const [form] = Form.useForm()

    useImperativeHandle(ref, () => ({
        resetReport () {
            form.resetFields()
        }
    }))

    const clearReport = () => {
        form.resetFields()
    }

    const handleSubmit = values => {
        const report = {
            obstacleDate: values.obstacleDate ? moment(values.obstacleDate).format('DD/MM/YYYY') : '',
            description: values.description !== undefined ? values.description : '',
            responsable: values.responsable !== undefined ? values.responsable : '',
            endDate: values.endDate ? moment(values.endDate).format('DD/MM/YYYY') : '',
            number: values.number !== undefined ? values.number : '',
        }
        onSubmitObstacleWorkOrder(report)
    }

    const getAutoNumber = () => {
        return obstacles.length + 1
    }

    return (
        <Grid>
            <Form onFinish={handleSubmit} form={form} initialValues={{obstacleDate: moment(), number:getAutoNumber()}}>
                <Row>
                    <Col xs={12} md={6}>
                        <Form.Item name="number">
                            <InputNumber disabled placeholder='Numero' style={{ width: '100%' }}/>
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={6}>
                        <Form.Item name="obstacleDate">
                            <DatePicker format={'DD/MM/YYYY'} placeholder="Fecha" style={{ width: '100%' }}/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row>
                    <Col xs={12} md={6}>
                        <Form.Item name="responsable" rules={[{ required: true, message: 'Ingrese un responsable de la traba' }]}>
                            <Input placeholder='Responsable'/>
                        </Form.Item>
                    </Col>
                    <Col xs={12} md={6}>
                    <Form.Item name="description" rules={[{ required: true, message: 'Ingrese una descripcion' }]}>
                            <TextArea placeholder="Descripción"/>
                        </Form.Item>
                    </Col>
                </Row>
                <Row center="xs">
                    <Col xs={6}>
                        <Form.Item style={{ textAlign: 'center' }}>
                            <Button type="primary" htmlType="submit" loading={loading}>
                                Cargar
                            </Button>
                        </Form.Item>
                    </Col>
                    <Col xs={6}>
                        <Form.Item style={{ textAlign: 'center' }}>
                            <Button onClick={clearReport} loading={loading}>
                                Limpiar
                            </Button>
                        </Form.Item>
                    </Col>
                </Row>
            </Form>
        </Grid>
    )
})

FormObstaclesWorkOrder.propTypes = {
    loading: PropTypes.bool.isRequired,
    onSubmitObstacleWorkOrder: PropTypes.func.isRequired
}

export default FormObstaclesWorkOrder
